var _path, _path2, _path3, _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleCheckmarkIconWithWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#80C68F",
    fillOpacity: 0.39,
    stroke: "#73ABA7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.6L11.1 16.2L17.1 9",
    stroke: "#73ABA7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4148_11606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1276 23.2356C20.4286 23.2034 22.2677 21.312 22.2355 19.0111C22.2033 16.7101 20.3119 14.8709 18.011 14.9031C15.71 14.9353 13.8708 16.8267 13.903 19.1277C13.9352 21.4286 15.8266 23.2678 18.1276 23.2356Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 16.9863L18.075 19.4861L18.04 16.9863ZM18.0954 20.9443L18.0983 21.1526L18.0954 20.9443Z",
    fill: "#F3C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0954 20.9443L18.0983 21.1526M18.04 16.9863L18.075 19.4861L18.04 16.9863Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4148_11606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1276 23.2356C20.4286 23.2034 22.2677 21.312 22.2355 19.0111C22.2033 16.7101 20.3119 14.8709 18.011 14.9031C15.71 14.9353 13.8708 16.8267 13.903 19.1277C13.9352 21.4286 15.8266 23.2678 18.1276 23.2356Z",
    fill: "#D69D0C",
    fillOpacity: 0.3,
    stroke: "#DEA30C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 16.9863L18.075 19.4861L18.04 16.9863ZM18.0954 20.9443L18.0983 21.1526L18.0954 20.9443Z",
    fill: "#F3C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0954 20.9443L18.0983 21.1526M18.04 16.9863L18.075 19.4861L18.04 16.9863Z",
    stroke: "#DEA30C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4148_11606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(13 14.1401) rotate(-0.801784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4148_11606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(13 14.1401) rotate(-0.801784)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckmarkIconWithWarn);
export default __webpack_public_path__ + "static/media/circleCheckmarkIconWithWarn.d6520a47e60afe1d5b9bbcc491b0fddb.svg";
export { ForwardRef as ReactComponent };